<div class="assistant-avatar">
  <app-voice-robot class="assistant-avatar__robot" [size]="96" [state]="state()" />

  <div class="assistant-avatar__bubble">
    <div class="assistant-avatar__identity">
      <span class="assistant-avatar__name">Koffi</span>
      <span class="assistant-avatar__beta">bêta</span>
    </div>
    <p class="assistant-avatar__greeting">{{ greeting() }}</p>
  </div>
</div>
